module.exports = __webpack_public_path__ + "img/Ellipse_20.0854c7ca.png";